module.exports = __webpack_public_path__ + "images/interior-3d-2-635835cdbcfc3ce85efb9bb25ab1d0cd.jpg";